import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment";
import { formatNumber, truncateText } from "../../../../../../utility/helper";
import { FaEdit, FaRegTrashAlt } from "react-icons/fa";
import { Pagination } from "../../../../../../components/Stepper/fields/inputField";

const MovementComponent = ({
  viewTransaction,
  viewFutureTransaction,
  handleOptionSelect,
  confirmDelete,
  setLimit,
  limit,
  setPage,
  page,
  selectedAsset,
  isNegativeROI,
}) => {
  const [loading, setLoading] = useState(false);

  const onPageChange = (e) => {
    setPage(e.page);
    setLimit(e.rows);
  };

  const reasonTemplate = (rowData) => {
    return rowData.remark ? truncateText(rowData.reason, 19) : "-";
  };

  const quantityTemplate = (rowData) => {
    return rowData.quantity ? rowData.quantity : "-";
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <button
          disabled={rowData?.is_initial}
          className={`focus:outline-none mr-2 ${
            rowData?.is_initial
              ? "dark:text-gray-400 text-info cursor-not-allowed"
              : "text-primary dark:text-primary"
          }`}
        >
          <FaEdit
            onClick={() => {
              if (!rowData?.is_default) {
                handleOptionSelect(rowData.type, "Update", rowData);
              }
            }}
          />
        </button>
        <button
          disabled={rowData?.is_initial}
          className={`focus:outline-none ${
            rowData?.is_initial
              ? "dark:text-gray-400 text-info cursor-not-allowed"
              : "text-darkWaring"
          }`}
        >
          <FaRegTrashAlt
            onClick={() => {
              if (!rowData?.is_default) {
                confirmDelete(rowData);
              }
            }}
          />
        </button>
      </div>
    );
  };

  const dateTemplate = (rowData) => {
    return moment(rowData.date).format("DD-MM-YYYY");
  };

  const cashTemplate = (rowData) => {
    const cashValue = rowData.amount ? rowData.amount : "";
    const type = rowData.type?.toUpperCase();

    return type === "OUT" || type === "EXPENSE" ? (
      <>-{formatNumber(cashValue)}</>
    ) : type === "IN" || type === "INCOME" ? (
      <>{formatNumber(cashValue)}</>
    ) : null;
  };

  const CostPriceTemplate = (rowData) => {
    const cashValue = rowData.cost_price || "";
    const type = rowData.type?.toUpperCase();

    if (type === "OUT" || type === "EXPENSE") {
      return cashValue == 0 ? "-" : <>-{formatNumber(cashValue)}</>;
    }

    if (type === "IN" || type === "INCOME") {
      return cashValue == 0 ? "-" : <>{formatNumber(cashValue)}</>;
    }

    return null;
  };

  return (
    <div className="border border-lightPrimary/40 dark:border-info/40 mt-6 pb-4 dark:bg-custom-radial bg-white md:px-0 px-4">
      <h2
        className={`text-2xl font-semibold inline-block p-4 ${
          isNegativeROI
            ? "dark:text-warning text-expense"
            : "text-lightPrimary dark:text-primary-gradient"
        }`}
      >
        {selectedAsset?.name
          ? `Stock - ${selectedAsset?.name}`
          : "No Stock found"}
      </h2>
      <DataTable
        value={viewTransaction?.transactions}
        className="transaction mt-3"
        sortMode="multiple"
        rows={limit}
        totalRecords={viewTransaction?.total}
        first={page * limit}
        onPage={onPageChange}
        loading={loading}
        emptyMessage="No data available"
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        <Column
          field="date"
          header="Date"
          body={dateTemplate}
          headerClassName={`text-xl font-normal ${
            isNegativeROI
              ? "!text-expense dark:!text-warning"
              : "!text-lightPrimary dark:!text-primary-gradient"
          }`}
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="type"
          header="Type"
          style={{ width: "13%" }}
          headerClassName={`text-xl font-normal ${
            isNegativeROI
              ? "!text-expense dark:!text-warning"
              : "!text-lightPrimary dark:!text-primary-gradient"
          }`}
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="remark"
          header="Reason"
          body={reasonTemplate}
          style={{ width: "10%" }}
          headerClassName={`text-xl font-normal ${
            isNegativeROI
              ? "!text-expense dark:!text-warning"
              : "!text-lightPrimary dark:!text-primary-gradient"
          }`}
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="quantity"
          header="Quantity"
          body={quantityTemplate}
          align="right"
          style={{ width: "10%" }}
          headerClassName={`text-xl font-normal ${
            isNegativeROI
              ? "!text-expense dark:!text-warning"
              : "!text-lightPrimary dark:!text-primary-gradient"
          }`}
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="cost_price"
          header="Unit Price"
          body={CostPriceTemplate}
          align="right"
          style={{ width: "10%" }}
          headerClassName={`text-xl font-normal ${
            isNegativeROI
              ? "!text-expense dark:!text-warning"
              : "!text-lightPrimary dark:!text-primary-gradient"
          }`}
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="asset_type_name"
          header="Asset"
          style={{ width: "13%" }}
          align="right"
          headerClassName={`text-xl font-normal ${
            isNegativeROI
              ? "!text-expense dark:!text-warning"
              : "!text-lightPrimary dark:!text-primary-gradient"
          }`}
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="amount"
          header="Cash"
          body={cashTemplate}
          align="right"
          style={{ width: "16%" }}
          headerClassName={`text-xl font-normal ${
            isNegativeROI
              ? "!text-expense dark:!text-warning"
              : "!text-lightPrimary dark:!text-primary-gradient"
          }`}
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="Action"
          header="Action"
          body={actionBodyTemplate}
          style={{ width: "15%" }}
          align="right"
          headerClassName={`text-xl font-normal ${
            isNegativeROI
              ? "!text-expense dark:!text-warning"
              : "!text-lightPrimary dark:!text-primary-gradient"
          }`}
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
      </DataTable>
      <Pagination
        page={page}
        limit={limit}
        total={viewTransaction?.total || 0}
        onPageChange={(newPage) => setPage(newPage)}
      />
      <div
        className={`mt-5 mb-3 pl-4 inline-block font-semibold ${
          isNegativeROI
            ? "text-expense dark:text-warning"
            : "text-lightPrimary text-black dark:text-primary-gradient"
        }`}
      >
        Future
      </div>
      <DataTable
        value={viewFutureTransaction?.transactions}
        className="transaction headerDisble"
        sortMode="multiple"
        rows={limit}
        totalRecords={viewFutureTransaction?.total}
        first={page * limit}
        emptyMessage="No data available"
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        <Column
          field="date"
          header="Date"
          body={dateTemplate}
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="type"
          header="Type"
          style={{ width: "13%" }}
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="remark"
          header="Reason"
          body={reasonTemplate}
          style={{ width: "10%" }}
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="quantity"
          header="Quantity"
          body={quantityTemplate}
          align="right"
          style={{ width: "10%" }}
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="cost_price"
          header="Unit Price"
          body={CostPriceTemplate}
          align="right"
          style={{ width: "10%" }}
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="asset_type_name"
          header="Asset"
          style={{ width: "13%" }}
          align="right"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="amount"
          header="Cash"
          body={cashTemplate}
          align="right"
          style={{ width: "16%" }}
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="Action"
          header="Action"
          body={actionBodyTemplate}
          style={{ width: "15%" }}
          align="right"
          headerClassName={`text-xl font-normal ${
            isNegativeROI
              ? "!text-expense dark:!text-warning"
              : "!text-lightPrimary dark:!text-primary-gradient"
          }`}
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
      </DataTable>
    </div>
  );
};

export default MovementComponent;
